<template>
	<span>
		<el-autocomplete
			@focus="loadAsyncSelectOptions(property.typeOptions.loadOptionsMethod)"
			style="width: 100%"
			v-if="property.type === 'options' && property.typeOptions"
			v-model="form[property.name]"
			:fetch-suggestions="
				(queryString, cb) => {
					autocompleteSearch(queryString, property.typeOptions, cb);
				}
			"
			:placeholder="property.placeholder || ''"
		></el-autocomplete>
		<el-select
			@change="
				() => {
					if (property.name === 'authentication' || property.name === 'genericAuthType') {
						$emit('authenticationValChanged');
					}
					if (property.valueChangeOptions) {
						executeValueChangeOptions(property.valueChangeOptions);
					}
				}
			"
			v-if="
				((property.type === 'options' && !property.typeOptions) || property.type === 'multiOptions') &&
				resetSelectValue(property, property.type)
			"
			no-data-text="No options found"
			no-match-text="No options found"
			:multiple="property.type === 'multiOptions' ? true : false"
			filterable
			style="width: 100%"
			v-model="form[property.name]"
			placeholder="Select"
			@focus="
				() => {
					if (property.typeOptions && property.typeOptions.loadOptionsMethod) {
						loadAsyncSelectOptions(property.typeOptions.loadOptionsMethod);
					}
				}
			"
		>
			<span v-if="(property.type === 'options' || property.type === 'multiOptions') && !property.typeOptions">
				<el-option
					v-for="(option, i) in property.options"
					:key="option.value + '_' + i"
					:label="option.name"
					:value="option.value"
				>
					<el-tooltip
						v-if="option.description"
						effect="dark"
						:content="option.description"
						placement="top-start"
					>
						<span>{{ option.name }}</span>
					</el-tooltip>
				</el-option>
			</span>
			<span
				v-if="
					property.type === 'multiOptions' && property.typeOptions && property.typeOptions.loadOptionsMethod
				"
			>
				<el-option
					v-for="(option, i) in asyncOptionsForMethodName[property.typeOptions.loadOptionsMethod]"
					:key="option.value + '_' + i"
					:label="option.name"
					:value="option.value"
				>
					<el-tooltip
						v-if="option.description"
						effect="dark"
						:content="option.description"
						placement="top-start"
					>
						<span>{{ option.name }}</span>
					</el-tooltip>
				</el-option>
			</span>
		</el-select>
	</span>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
	props: {
		property: Object,
		form: Object,
		integrationInterface: Object,
	},
	computed: {
		...mapGetters(["returnActiveWorkflow"]),
	},
	data() {
		return {
			asyncOptionsForMethodName: {},
		};
	},
	methods: {
		...mapActions(["updateInputsOutputsForNodeMETHOD"]),
		resetSelectValue(property, selectType) {
			if (property.options) {
				const optionValues = property.options.map((each) => {
					return each.value;
				});
				if (selectType === "options") {
					if (!optionValues.includes(this.form[property.name])) {
						this.form[property.name] = property.default;
					}
				} else if (selectType === "multiOptions") {
					if (!this.form[property.name].every((v) => optionValues.includes(v))) {
						this.form[property.name] = property.default;
					}
				}
			}
			return true;
		},
		async autocompleteSearch(queryString, typeOptions, cb) {
			const loadOptionsMethod = typeOptions.loadOptionsMethod;
			let options = (this.asyncOptionsForMethodName[loadOptionsMethod] || []).filter((each) => {
				return each.value.includes(queryString);
			});
			options = options.filter((each, i) => {
				if (i <= 20) {
					//Limit output size for performance reasons, some apis return alot of data
					return each;
				}
			});
			cb(options);
		},
		async loadAsyncSelectOptions(loadOptionsMethod) {
			const result = await this.httpHelper("RUNTIME", "POST", "workflow/returnNodeInterfaceData", {
				workflowId: this.returnActiveWorkflow.id,
				versionId: this.returnActiveWorkflow.versionId,
				methodName: loadOptionsMethod,
				nodeId: this.integrationInterface.id,
				parameters: this.form,
			});
			this.$set(
				this.asyncOptionsForMethodName,
				loadOptionsMethod,
				Array.isArray(result.response) ? result.response : []
			);
			return true;
		},
		async executeValueChangeOptions(valueChangeOptions) {
			const result = await this.httpHelper("RUNTIME", "POST", "workflow/returnNodeInterfaceData", {
				workflowId: this.returnActiveWorkflow.id,
				versionId: this.returnActiveWorkflow.versionId,
				methodName: valueChangeOptions.changeInputOutputRestrictionsMethod,
				nodeId: this.integrationInterface.id,
				parameters: this.form,
			});
			const inputs = result.response.inputs || [];
			const outputs = result.response.outputs || [];
			const destroyExistingConnections = valueChangeOptions.destroyConnectionsOnChange;
			this.updateInputsOutputsForNodeMETHOD({
				nodeId: this.integrationInterface.id,
				inputs,
				outputs,
				destroyExistingConnections,
			});
		},
	},
};
</script>

<style scoped></style>
